/**
 * S1402 — le message de la chargée à l'accueil : ce qui se lit, ce qui
 * s'écrit. Rien de médical.
 */
import { z } from 'zod';
import { MESSAGE_ACCUEIL_MAX } from '../rules/message-accueil.js';
import { MESSAGE_CARACTERE_DE_CONTROLE, sansCaractereDeControle } from './note-chargee.js';
export const schemaMessageAccueil = z.object({
    texte: z.string(),
    /** Le nom de qui l'a écrit ou modifié en dernier. */
    auteur: z.string().nullable(),
    ecritLe: z.iso.datetime(),
});
/** Écrire ou modifier le message ; un texte vide le retire. */
export const schemaSaisieMessageAccueil = z
    .object({
    texte: z
        .string()
        .trim()
        .max(MESSAGE_ACCUEIL_MAX, `Le message tient en ${String(MESSAGE_ACCUEIL_MAX)} caractères au plus.`)
        .refine(sansCaractereDeControle, MESSAGE_CARACTERE_DE_CONTROLE),
})
    .strict();
/** Le message d'une fiche pour qui l'écrit, et s'il peut encore le modifier. */
export const schemaMessageAccueilDeLaFiche = z.object({
    message: schemaMessageAccueil.nullable(),
    modifiable: z.boolean(),
});
//# sourceMappingURL=message-accueil.js.map